/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export { ApiError } from './core/ApiError';
export { CancelablePromise, CancelError } from './core/CancelablePromise';
export { OpenAPI } from './core/OpenAPI';
export type { OpenAPIConfig } from './core/OpenAPI';

export type { Accessory } from './models/Accessory';
export type { AccessoryPrice } from './models/AccessoryPrice';
export { AccessoryType } from './models/AccessoryType';
export type { AddAccessoryItemToCartRequestV1 } from './models/AddAccessoryItemToCartRequestV1';
export type { AddArtworkToUserCustomCollectionRequest } from './models/AddArtworkToUserCustomCollectionRequest';
export type { AddArtworkToUserCustomCollectionResult } from './models/AddArtworkToUserCustomCollectionResult';
export type { AddSingleItemToCartRequest } from './models/AddSingleItemToCartRequest';
export type { AddSingleItemToCartRequestV2 } from './models/AddSingleItemToCartRequestV2';
export type { AddSingleItemToCartV3Response } from './models/AddSingleItemToCartV3Response';
export type { AddSingleItemToWishlist } from './models/AddSingleItemToWishlist';
export type { AddToCartEvent } from './models/AddToCartEvent';
export type { AddToCartEventContent } from './models/AddToCartEventContent';
export type { AddToWishlistEvent } from './models/AddToWishlistEvent';
export type { AddToWishlistEventContent } from './models/AddToWishlistEventContent';
export type { ArtworkCollectionV2 } from './models/ArtworkCollectionV2';
export { ArtworkOrientation } from './models/ArtworkOrientation';
export type { Author } from './models/Author';
export type { BrandsList } from './models/BrandsList';
export type { BrandsListItem } from './models/BrandsListItem';
export { BreadcrumbType } from './models/BreadcrumbType';
export type { BreadcrumbV2 } from './models/BreadcrumbV2';
export type { BreadcrumbV3 } from './models/BreadcrumbV3';
export type { BrowseCollectionsV2 } from './models/BrowseCollectionsV2';
export type { CartAddAccessoryResult } from './models/CartAddAccessoryResult';
export type { CartPreview } from './models/CartPreview';
export type { CartPreviewItem } from './models/CartPreviewItem';
export type { CartPreviewItemV2 } from './models/CartPreviewItemV2';
export type { CartPreviewV2 } from './models/CartPreviewV2';
export type { CategoriesWithCollectionsV2 } from './models/CategoriesWithCollectionsV2';
export type { CategoryV2 } from './models/CategoryV2';
export type { CategoryWithCollectionV2 } from './models/CategoryWithCollectionV2';
export type { CollectionsDataV2 } from './models/CollectionsDataV2';
export type { CollectionsV2 } from './models/CollectionsV2';
export { ContextAction } from './models/ContextAction';
export type { ContextActionPayload } from './models/ContextActionPayload';
export type { ContextActionRequest } from './models/ContextActionRequest';
export type { CreateUserCustomCollectionRequest } from './models/CreateUserCustomCollectionRequest';
export type { CreateUserCustomCollectionResult } from './models/CreateUserCustomCollectionResult';
export type { DisplateAuthorV2 } from './models/DisplateAuthorV2';
export type { DisplateAuthorV3 } from './models/DisplateAuthorV3';
export type { DisplatePdpFeeds } from './models/DisplatePdpFeeds';
export type { DisplatePdpFeedsV2 } from './models/DisplatePdpFeedsV2';
export type { DisplatePdpGeneralV2 } from './models/DisplatePdpGeneralV2';
export type { DisplatePdpGeneralV3 } from './models/DisplatePdpGeneralV3';
export type { DisplatePdpUserV1 } from './models/DisplatePdpUserV1';
export type { DisplateProductCategoryV2 } from './models/DisplateProductCategoryV2';
export type { DisplateProductCategoryV3 } from './models/DisplateProductCategoryV3';
export type { DisplateProductCollectionV2 } from './models/DisplateProductCollectionV2';
export type { DisplateProductCollectionV3 } from './models/DisplateProductCollectionV3';
export type { DisplateProductPromo } from './models/DisplateProductPromo';
export type { DisplateProductPromoBar } from './models/DisplateProductPromoBar';
export type { DisplateProductPromoV2 } from './models/DisplateProductPromoV2';
export type { DisplateProductPromoV3 } from './models/DisplateProductPromoV3';
export type { DisplateProductSeoV2 } from './models/DisplateProductSeoV2';
export type { DisplateProductSeoV3 } from './models/DisplateProductSeoV3';
export type { DisplateProductShop } from './models/DisplateProductShop';
export type { DisplateProductShopV2 } from './models/DisplateProductShopV2';
export type { DisplateProductShopV3 } from './models/DisplateProductShopV3';
export type { DisplateProductV2 } from './models/DisplateProductV2';
export type { DisplateProductV3 } from './models/DisplateProductV3';
export type { DisplateUserCustomCollection } from './models/DisplateUserCustomCollection';
export { Finish } from './models/Finish';
export type { Follow } from './models/Follow';
export type { FollowedArtwork } from './models/FollowedArtwork';
export type { FollowedArtworkV2 } from './models/FollowedArtworkV2';
export { Frame } from './models/Frame';
export type { GalleryItem } from './models/GalleryItem';
export type { GalleryItemV2 } from './models/GalleryItemV2';
export type { HeaderContent } from './models/HeaderContent';
export type { HealthResult } from './models/HealthResult';
export type { HealthStatus } from './models/HealthStatus';
export type { HomepageAuthor } from './models/HomepageAuthor';
export { HomepageBadgeType } from './models/HomepageBadgeType';
export type { HomepageBrand } from './models/HomepageBrand';
export type { HomepageBrandOfTheWeek } from './models/HomepageBrandOfTheWeek';
export type { HomepageBrandsFeedItem } from './models/HomepageBrandsFeedItem';
export type { HomepageCurrentEvent } from './models/HomepageCurrentEvent';
export type { HomepageEventFiles } from './models/HomepageEventFiles';
export type { HomepageFeaturedCollection } from './models/HomepageFeaturedCollection';
export type { HomepageFeaturedCollections } from './models/HomepageFeaturedCollections';
export type { HomepageFeaturedCollectionsCollection } from './models/HomepageFeaturedCollectionsCollection';
export type { HomepageFeaturedCollectionsImage } from './models/HomepageFeaturedCollectionsImage';
export type { HomepageFeaturedEventFiles } from './models/HomepageFeaturedEventFiles';
export type { HomepageFeaturedEventV2 } from './models/HomepageFeaturedEventV2';
export type { HomepageFeeds } from './models/HomepageFeeds';
export type { HomepageFeedsV2 } from './models/HomepageFeedsV2';
export type { HomepageGalleryItem } from './models/HomepageGalleryItem';
export type { HomepageUpcomingEvent } from './models/HomepageUpcomingEvent';
export type { HomepageUpcomingEventFilesV2 } from './models/HomepageUpcomingEventFilesV2';
export type { HomepageUpcomingEventV2 } from './models/HomepageUpcomingEventV2';
export type { HomepageV2 } from './models/HomepageV2';
export type { HomepageV3 } from './models/HomepageV3';
export type { HomepageV4 } from './models/HomepageV4';
export type { HomepageVideo } from './models/HomepageVideo';
export type { ImageSrcSet } from './models/ImageSrcSet';
export type { Keyword } from './models/Keyword';
export type { LuminoAuthorV4 } from './models/LuminoAuthorV4';
export type { LuminoCommonImageV3 } from './models/LuminoCommonImageV3';
export type { LuminoCommonListItemV4 } from './models/LuminoCommonListItemV4';
export type { LuminoDetailsV4 } from './models/LuminoDetailsV4';
export type { LuminoImagesV4 } from './models/LuminoImagesV4';
export type { LuminoListingItemV3 } from './models/LuminoListingItemV3';
export type { LuminoListingResponseV3 } from './models/LuminoListingResponseV3';
export type { LuminoListingsV3 } from './models/LuminoListingsV3';
export type { LuminoListsV4 } from './models/LuminoListsV4';
export type { LuminoMatchingArtworksV4 } from './models/LuminoMatchingArtworksV4';
export type { LuminoNewestItemV3 } from './models/LuminoNewestItemV3';
export { LuminoStatus } from './models/LuminoStatus';
export type { LuminoTextsV4 } from './models/LuminoTextsV4';
export type { LuminoUserListingV3 } from './models/LuminoUserListingV3';
export type { LuminoUserV3 } from './models/LuminoUserV3';
export type { LuminoV4 } from './models/LuminoV4';
export type { MerchantId } from './models/MerchantId';
export type { Metadata } from './models/Metadata';
export type { MonolithContextActionResponse } from './models/MonolithContextActionResponse';
export type { NewsletterSubscribeRequest } from './models/NewsletterSubscribeRequest';
export type { NewsletterSubscribeResult } from './models/NewsletterSubscribeResult';
export type { Notify } from './models/Notify';
export type { Object } from './models/Object';
export type { Page } from './models/Page';
export type { PagedResponse_FollowedArtwork_ } from './models/PagedResponse_FollowedArtwork_';
export type { PagedResponse_FollowedArtworkV2_ } from './models/PagedResponse_FollowedArtworkV2_';
export type { PagedWishlistItems } from './models/PagedWishlistItems';
export type { PhraseAutocomplete } from './models/PhraseAutocomplete';
export type { Price } from './models/Price';
export type { ProductFinish } from './models/ProductFinish';
export type { ProductFrame } from './models/ProductFrame';
export type { ProductSize } from './models/ProductSize';
export type { ProductVariants } from './models/ProductVariants';
export type { ProductViewedEvent } from './models/ProductViewedEvent';
export type { ProductViewedEventContent } from './models/ProductViewedEventContent';
export type { PromoBar } from './models/PromoBar';
export type { Recommended } from './models/Recommended';
export type { Seo } from './models/Seo';
export { SeoTagType } from './models/SeoTagType';
export type { ShareAndEarnCode } from './models/ShareAndEarnCode';
export type { SimpleTrustPilot } from './models/SimpleTrustPilot';
export { Size } from './models/Size';
export type { SliderCategory } from './models/SliderCategory';
export { Sort } from './models/Sort';
export type { SubscribedEvents } from './models/SubscribedEvents';
export { SubscriptionStatus } from './models/SubscriptionStatus';
export type { SuggestedPhrase } from './models/SuggestedPhrase';
export type { TagV2 } from './models/TagV2';
export type { TagV3 } from './models/TagV3';
export type { ThumbnailV2 } from './models/ThumbnailV2';
export type { TopBar } from './models/TopBar';
export type { TrustPilot } from './models/TrustPilot';
export type { TrustPilotReview } from './models/TrustPilotReview';
export { UserAccountRole } from './models/UserAccountRole';
export { UserAccountRoleV2 } from './models/UserAccountRoleV2';
export { UserDownloadRights } from './models/UserDownloadRights';
export { UserDownloadRightsV2 } from './models/UserDownloadRightsV2';
export type { UserInfo } from './models/UserInfo';
export type { UserInfoV2 } from './models/UserInfoV2';
export type { WishlistItem } from './models/WishlistItem';
export type { WishlistItemImages } from './models/WishlistItemImages';

export { BfwGeneralDataService } from './services/BfwGeneralDataService';
export { BfwUserContextService } from './services/BfwUserContextService';
export { DefaultService } from './services/DefaultService';
